import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  @Input() mailText = '';

  constructor(private readonly router: Router) {}

  get showNewsLink(): boolean {
    return this.router.url === '/' || this.router.url === '';
  }

  get isNewsRoute(): boolean {
    return this.router.url.startsWith('/news');
  }
}
